import { render, staticRenderFns } from "./Chatbot.vue?vue&type=template&id=6a2b46cc&scoped=true"
import script from "./Chatbot.vue?vue&type=script&lang=js"
export * from "./Chatbot.vue?vue&type=script&lang=js"
import style0 from "./Chatbot.vue?vue&type=style&index=0&id=6a2b46cc&prod&lang=scss&scoped=true"
import style1 from "./Chatbot.vue?vue&type=style&index=1&id=6a2b46cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2b46cc",
  null
  
)

export default component.exports